module.exports = __webpack_public_path__ + "img/how-to-use-header.6f8864e7.png";